import { cashDrawerApi } from '../../api';
import { CashDrawerRegistrationForm } from '../../types/hardware/CashDrawerTypes';

const CashDrawerService = {
    /**
     * Obtiene todos los cajones de dinero registrados.
     * GET /api/cash-drawers
     */
    getAll: async () => {
        const response = await cashDrawerApi.fetchAll();
        return response.data;
    },

    /**
     * Obtiene los detalles de un cajón de dinero por su ID.
     * GET /api/cash-drawers/{id}
     */
    getById: async (id: number) => {
        const response = await cashDrawerApi.fetchById(id);
        return response.data;
    },

    /**
     * Registra un nuevo cajón de dinero.
     * POST /api/cash-drawers
     */
    create: async (data: CashDrawerRegistrationForm): Promise<void> => {
        const response = await cashDrawerApi.add(data);
        return response.data;
    },

    /**
     * Actualiza un cajón de dinero existente.
     * PUT /api/cash-drawers/{id}
     */
    update: async (id: number, data: CashDrawerRegistrationForm): Promise<void> => {
        const response = await cashDrawerApi.modify(id, data);
        return response.data;
    },

    /**
     * Cambia el estado activo/inactivo de un cajón.
     * PATCH /api/cash-drawers/{id}/toggle
     */
    toggleStatus: async (id: number) => {
        const response = await cashDrawerApi.patchCustom(`${id}/toggle`);
        return response.data;
    },
};

export default CashDrawerService;
